var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoomoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YooMoney",
    clipPath: "url(#clip0_342:15908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9 3.04993C8.95 3.04993 5.8 6.14993 5.8 9.99993C5.8 13.8499 9 16.9499 12.9 16.9499C16.8 16.9499 20 13.8499 20 9.99993C20.05 6.14993 16.8 3.04993 12.9 3.04993ZM12.9 12.5499C11.45 12.5499 10.2 11.3999 10.2 9.99993C10.2 8.59993 11.4 7.44993 12.9 7.44993C14.4 7.44993 15.6 8.59993 15.6 9.99993C15.5 11.3999 14.4 12.5499 12.9 12.5499ZM5.75 5.09993V15.2499H3.25L0 5.09993H5.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342:15908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoomoney);
export default __webpack_public_path__ + "static/media/yoomoney.db6736218a2d7c34693fed6ffcbdb433.svg";
export { ForwardRef as ReactComponent };